import 'css-chunksrc/client/scenes/projectFromPortfolioRemoval/styles.scss';export default {
  "header": "_header_at2bu_1",
  "text": "_text_at2bu_5",
  "name": "_name_at2bu_11",
  "main": "_main_at2bu_17",
  "buttons": "_buttons_at2bu_24"
};